export const INPUT_TYPE = {
  FILE: 'file',
  TEXT: 'text',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
  PASSWORD: 'password',
} as const;

export type InputType = (typeof INPUT_TYPE)[keyof typeof INPUT_TYPE];
